import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { PageResult } from '@core/model/pagination/page-result';
import { TicketLabor, TicketLaborGridUpdate } from '../../models/ticket-labor';
import { FormGroup } from '@angular/forms';
import { InputMask } from '@core/mask/input-mask';
import { TicketLabourService } from '../../services/ticket-labour.service';
import { ValidationService } from '@shared/services/validation.service';
import { NotifyService } from '@core/services/notify.service';
import { UserService } from '@shared/services/user.service';
import { AuthService } from '@core/services/auth.service';
import { PageFilter } from '@core/model/pagination/filter';
import { Salary, SalarySetup } from '@core/model/employee/salary';
import { AppUtilService } from '@shared/services/app-util.service';
import { noCommaValue } from '@core/mask/remove-comma';
import { Ticket } from '../../models/tickets';
import { TicketsStatusChange, UpdateTicketPrimaryAssignee } from '../../models/ticket-status-change';
import { TicketStatusChangeService } from '../../services/ticket-status-change.service';
import { TicketsService } from '../../services/tickets.service';
import { LaborRateType, SalaryRateType } from '@core/enums/ticket-labor';

@Component({
  selector: 'app-team-hour',
  standalone: false,
  templateUrl: './team-hour.component.html',
  styleUrl: './team-hour.component.css',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '*'
      })),
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        padding: '0'
      })),
      transition('expanded <=> collapsed', [
        animate('500ms ease')
      ]),
    ])
  ]
})
export class TeamHourComponent implements OnInit, OnChanges {

 @Input() ticketId: string;
 @Input() getTicket: Ticket;
 @Input() isChange= 0;
 @Input() isCompleted : boolean;
 @Output() updateTicket = new EventEmitter<boolean>();
 @Output() isChangeAnyThing = new EventEmitter<number>();

  expandedIndex = -1; // none expanded initially
ticketlaborList: PageResult<TicketLabor> = new PageResult<TicketLabor>();
  ticketlabor: TicketLabor = new TicketLabor();
  form: FormGroup;
  mask = InputMask.getDecimalMask({ includeThousandsSeparator: true });
  workerId:string;
  loading = false;
  pageFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 0,
    take: 100,
    search: '',
    skip:0,
  };
  laborHourRate: Salary[] = [];
  isDialog=false

assignees: { id: string | null; fullName: string | null; rHours: string | null; otHours: string | null ;emHours: string | null;
  rbHours: string | null; obHours: string | null; rRate: string | null ;otRate: string | null;pic: string | null
}[] =
  [{ id: null, fullName: null ,rHours: null, otHours: null, emHours: null,rbHours: null, obHours: null, rRate: null, otRate: null, pic: null}];
currentWorkerId:string;
isManager = true;
 regularHours: string;
  overTimeHours: string;
  estimatedHours: string;
  lastIndex=-1;
  changePrimaryAssignee=0;
  primaryAssigneeId: string;
  laborRateType = LaborRateType;
  salaryRateType = SalaryRateType;

  constructor(
    private service: TicketLabourService,
    private ticketStatusService: TicketStatusChangeService,
    public validationService: ValidationService,
    private notifyService: NotifyService,
    public userService: UserService,
    private authService: AuthService,
    public ticketService: TicketsService,
    public appUtilService: AppUtilService,
  )
  {
    this.loading=true;
    // Manually listen for ESC key inside this dialog
    
  }
  toggle(index: number) {
    this.changePrimaryAssignee = 0;
    this.expandedIndex = this.expandedIndex === index ? -1 : index;
    if(this.lastIndex >=0){
      const selectedWorkerId = this.assignees[this.lastIndex].id;
      const getLaborR = this.ticketlaborList?.data.find(x => x.workerId == selectedWorkerId && x.hoursType == this.laborRateType.Regular);
      const getLaborO = this.ticketlaborList?.data.find(x => x.workerId == selectedWorkerId && x.hoursType == this.laborRateType.OverTime);
      this.assignees[this.lastIndex].emHours = getLaborR.estimated.toString();
      this.assignees[this.lastIndex].rHours = getLaborR.hours.toString();
      this.assignees[this.lastIndex].otHours = getLaborO.hours.toString();

      this.assignees[this.lastIndex].rbHours = getLaborR.billable.toString();
      this.assignees[this.lastIndex].obHours = getLaborO.billable.toString();
      this.assignees[this.lastIndex].rRate = getLaborR.rate>0? getLaborR.rate.toString(): this.getHourlyRateByUserId(selectedWorkerId, this.salaryRateType.Regular).toString();
      this.assignees[this.lastIndex].otRate = getLaborO.rate.toString();

      this.lastIndex = -1;
    }
  }

  public async ngOnInit() {
    
    this.workerId = this.authService.id;
    this.primaryAssigneeId = await this.getLatestChangeStatus(this.getTicket).assignedUserId;
    if (this.ticketId) {
      await this.getData();
    }

  }
loadSkelton(): boolean{
  return this.loading;
}
  async getData(){
    this.loading = true;
      const ticketlabor = await this.service.getPaginatedTicketLabors(
        this.pageFilter,
        this.ticketId
      );
      this.laborHourRate = await this.service.getLaborWorkingHourRate(this.ticketId);
      const distinctLabors = ticketlabor.data.reduce((acc, labor) => {
        if (!acc.some((item) => item.workerId === labor.workerId)) {
          acc.push(labor);
        }
        return acc;
      }, []);
if (this.primaryAssigneeId != null) {
    const idx = distinctLabors.findIndex(l => l.workerId === this.primaryAssigneeId);
    if (idx > 0) {                       // >0 so it’s not already first
      const [priorityLabor] = distinctLabors.splice(idx, 1);
      distinctLabors.unshift(priorityLabor);
    }
  }
     // Fill assignees with distinct data
  this.assignees = distinctLabors.map((labor) => ({
    id: labor.workerId,
    fullName: labor.workerName || 'N/A',
    rHours: this.findWorkerHours(ticketlabor.data,labor.workerId,this.laborRateType.Regular),
    otHours: this.findWorkerHours(ticketlabor.data,labor.workerId,this.laborRateType.OverTime),
    emHours: this.findWorkerEstimatedHours(ticketlabor.data,labor.workerId,this.laborRateType.Regular),
    rbHours: this.findWorker(ticketlabor.data,labor.workerId,this.laborRateType.Regular).billable.toString(),
    obHours: this.findWorker(ticketlabor.data,labor.workerId,this.laborRateType.OverTime).billable.toString(),
    rRate: this.findWorker(ticketlabor.data,labor.workerId,this.laborRateType.Regular).rate>0?this.findWorker(ticketlabor.data,labor.workerId,this.laborRateType.Regular).rate.toString(): this.getHourlyRateByUserId(labor.workerId, this.salaryRateType.Regular).toString(),
    otRate: this.findWorker(ticketlabor.data,labor.workerId,this.laborRateType.OverTime).rate.toString(),
    pic: labor.workerPic,

  }));

  // Add an empty entry for new assignments if required

      this.ticketlaborList = {
        ...ticketlabor,
        data: ticketlabor.data.map(item => ({
          ...item,
          total: Number((item.billable * item.rate).toFixed(2)) // Convert the result back to number
        }))
      };
      
      this.loading = false;
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes && this.isChange>0) {
      await this.ngOnInit();
    }
  }

  findWorkerHours(labor: TicketLabor[],workerId:string, hourType: string){
    return labor.find(x => x.workerId == workerId && x.hoursType == hourType).hours.toString();
  }

  findWorkerEstimatedHours(labor: TicketLabor[],workerId:string, hourType: string){
    const foundLabor = labor.find(x => x.workerId === workerId && x.hoursType === hourType);

    if (!foundLabor || isNaN(parseFloat(foundLabor.estimated.toString()))) {
        return "0"; // Return 0 if no valid value is found
    }

    const estimatedValue = parseFloat(foundLabor.estimated.toString());


    return estimatedValue.toString();
  }

  findWorker(labor: TicketLabor[],workerId:string, hourType: string): TicketLabor{
    return labor.find(x => x.workerId == workerId && x.hoursType == hourType);
  }

  getSumOfHours(rValue: string, otValue: string): number {
    const r = Number(noCommaValue(String(rValue ?? '').trim())) || 0;
    const o = Number(noCommaValue(String(otValue ?? '').trim())) || 0;
    const result = r + o;
    return Number.isNaN(result) ? 0 : result;
  }

  getTotalCost(rate:string, hours: string){
    const result = parseInt(rate) * parseInt(hours);
    return !result || Number.isNaN(result)? 0: result;
  }

  formatHeaderValue(value: string): string {
    if (value == null || String(value).trim() === '') {
      return '0';
    }
    const trimmed = String(value).trim();
    const num = Number(noCommaValue(trimmed));
    if (Number.isNaN(num) || num === 0) {
      return '0';
    }
    return trimmed;
  }
  onChangeRegularHours(event:Event, index: number, ){
    const inputElement = event.target as HTMLInputElement;
    const value = (inputElement.value);
    this.regularHours = value;
      this.assignees[index].rHours = this.regularHours.toString();
      this.lastIndex = index;
  }
  onChangeOverTimeHours(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.overTimeHours = (value);
    this.assignees[index].otHours = this.overTimeHours.toString();
      this.lastIndex = index;
  }
  onChangeBillableOverTimeHours(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.assignees[index].obHours = value.toString();
      this.lastIndex = index;
  }
  onChangeBillableRegularHours(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.assignees[index].rbHours = value.toString();
      this.lastIndex = index;
  }

  onChangeOverTimeRate(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.assignees[index].otRate = value.toString();
      this.lastIndex = index;
  }

  onChangeRegularRate(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.assignees[index].rRate = value.toString();
      this.lastIndex = index;
  }
  safeNumber(value: string, fallback = 0): number {
    const parsed = Number(noCommaValue(value));
    return isNaN(parsed) ? fallback : parsed;
  }
  async onSubmitLaborHours( index:number){
    const rHours = this.safeNumber(this.assignees[index].rHours);
    const otHours = this.safeNumber(this.assignees[index].otHours);
    const rbHours = this.safeNumber(this.assignees[index].rbHours);
    const obHours = this.safeNumber(this.assignees[index].obHours);
    const rRate = this.safeNumber(this.assignees[index].rRate);
    const otRate = this.safeNumber(this.assignees[index].otRate);
    if((rHours === 0 && (this.assignees[index].rHours.length>0 && this.assignees[index].rHours !== '0')) ||
        (otHours === 0 && (this.assignees[index].otHours.length>0 && this.assignees[index].otHours !== '0')) || 
      (rbHours === 0 && (this.assignees[index].rbHours.length>0 && this.assignees[index].rbHours !== '0')) ||
    (obHours === 0 && (this.assignees[index].obHours.length>0 && this.assignees[index].obHours !== '0'))){
       this.notifyService.error({
            message: 'Please enter valid hours.',
      });
      this.assignees[index].rHours = rHours.toString();
      this.assignees[index].otHours = otHours.toString();
      this.assignees[index].rbHours = rbHours.toString();
      this.assignees[index].obHours = obHours.toString();
      return;
    }

    if((rRate === 0 && (this.assignees[index].rRate.length>0 && this.assignees[index].rRate !== '0')) ||
        (otRate === 0 && (this.assignees[index].otRate.length>0 && this.assignees[index].otRate !== '0')) ){
       this.notifyService.error({
            message: 'Please enter valid hours rate.',
      });
      this.assignees[index].rRate = rRate.toString();
      this.assignees[index].otRate = otRate.toString();
      return;
    }
    if(this.assignees[index].rHours.includes('-') || this.assignees[index].otHours.includes('-') || this.assignees[index].rbHours.includes('-') || this.assignees[index].obHours.includes('-') 
      || this.assignees[index].rRate.includes('-') || this.assignees[index].otRate.includes('-')){
              this.notifyService.error({
                message: 'Negative values are not allowed.',
              });
        return;
      }

      // if(this.assignees[index].rHours.includes('.') || this.assignees[index].otHours.includes('.') || this.assignees[index].rbHours.includes('.') || this.assignees[index].obHours.includes('.') 
      // || this.assignees[index].rRate.includes('.') || this.assignees[index].otRate.includes('.')){
      //         this.notifyService.error({
      //           message: 'Please enter whole numbers only.',
      //         });
      //   return;
      // }

    const labor = new TicketLaborGridUpdate();
      labor.createdBy = this.workerId;
      labor.workerId = this.assignees[index].id;
      labor.ticketId = this.ticketId;
      labor.regularHours=rHours;
      labor.overTimeHours=otHours;
      labor.regularBillable = rbHours;
      labor.overTimeBillable = obHours;
      labor.regularRate = rRate;
      labor.overTimeRate = otRate;

    await this.service
        .updateTicketLaborHours(labor)
        .then(async () => {

          this.loading=false;
          this.regularHours ='';
          this.overTimeHours = '';
          this.expandedIndex = -1;
          this.lastIndex = -1;
          this.getData();
          this.isChangeAnyThing.emit(1);
        })
        .catch((error) => {
          this.loading = false;
          error = error.graphQLErrors[0];
          if (error) {
            this.notifyService.error({
              message: error.message,
              type: error.extensions.type,
            });
          } else {
            this.notifyService.error({
              message: 'Failed to add worker hours.',
            });
          }
        });
  }

  getLatestChangeStatus(ticketChange: Ticket): TicketsStatusChange | undefined {
  if (ticketChange?.ticketStatusChanges?.length > 0) {
    return ticketChange.ticketStatusChanges.reduce<TicketsStatusChange | undefined>(
      (latest, change) => {
        if (!latest?.changeOn) return change;
        if (!change.changeOn) return latest;
        return new Date(latest.changeOn) > new Date(change.changeOn)
          ? latest
          : change;
      },
      undefined // initial value
    );
  }
  return undefined;
}

  checkParimaryAssignee(workerId:string){
    const assigneeId = this.primaryAssigneeId;
    return workerId == assigneeId? true: false;
  }

  async onSubmitPrimaryAssignee(workerId: string){
    const labor = new UpdateTicketPrimaryAssignee();
      labor.changeById = this.workerId;
      labor.assignedUserId = workerId
      labor.ticketId = this.ticketId;

    await this.ticketStatusService
        .updateTicketPrimaryAssignee(labor)
        .then(async () => {

          this.loading=false;
          this.regularHours ='';
          this.overTimeHours = '';
          this.expandedIndex = -1;
          this.lastIndex = -1;
          this.changePrimaryAssignee = 0;
          this.updateTicket.emit(true);
          this.getData();
        })
        .catch((error) => {
          this.loading = false;
          error = error.graphQLErrors[0];
          if (error) {
            this.notifyService.error({
              message: error.message,
              type: error.extensions.type,
            });
          } else {
            this.notifyService.error({
              message: 'Failed to add primary assignee.',
            });
          }
        });
  }

  onChangePrimaryAssignee(){
this.changePrimaryAssignee = 1;
  }

  async onRemoveSecondary(selectedWorkerId:string){
    const labor = new TicketLabor();
    labor.createdOn = new Date();
      labor.createdById = this.workerId;
      labor.updatedOn = new Date();
      labor.updatedById = this.workerId;
      labor.workerId = selectedWorkerId;
      labor.ticketId = this.ticketId;
        labor.hours=0;
        labor.rate=0;
        labor.billable = 0
        labor.hoursType=this.laborRateType.Regular;
    await this.service
        .removeTicketWorker(labor)
        .then(async () => {
          this.changePrimaryAssignee=0;
          this.getData();
          this.updateTicket.emit(true);
        })
        .catch((error) => {
          error = error.graphQLErrors[0];
          if (error) {
            this.notifyService.error({
              message: error.message,
              type: error.extensions.type,
            });
          } else {
            this.notifyService.error({
              message: 'Failed to remove ticket member.',
            });
          }
        });
  }

  assigned(){
    return this.assignees?.length>0 && this.assignees[0]?.id? true: false;
  }

  UpdateTicket(){
    this.ngOnInit();
  }

  getTotalEstimatedHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor: TicketLabor) => {
      return acc + (labor.estimated || 0);
    }, 0);
  }

  getHourlyRateByUserId(userId: string, type:string): number | null {
    // Find the salary record for the given userId
    const salary = this.laborHourRate.find(s => s.userId === userId);
    
    if (!salary || !salary.salarySetup) {
      return 0; // Return null if no record is found or salarySetup is missing
    }
  
    try {
      // Parse the salarySetup JSON
      const salarySetup: SalarySetup = JSON.parse(salary.salarySetup);
  
      // Ensure it's an hourly salary type and contains the expected structure
      if(type == this.salaryRateType.Regular){
        if (salarySetup.SalaryType === "Hourly" && "EmployeeRate" in salarySetup.Setup) {
          return salarySetup.Setup.InternalRate.RegularRate; // Return RegularRate
        }
      }
      else if(type == this.salaryRateType.OverTime){
        if (salarySetup.SalaryType === "Hourly" && "EmployeeRate" in salarySetup.Setup) {
          return salarySetup.Setup.InternalRate.OvertimeRate; // Return RegularRate
        }
      }
      return 0; // Return null if it's not the expected format
    } catch (error) {
      console.error("Error parsing salarySetup JSON:", error);
      return 0;
    }
  }
  checkUserPermissions(permission: string){
    return this.authService.hasPermission(permission)?? null;
  }
}
